import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { getRelatedCourses } from 'src/common/services/course';
import { isNilEmpty } from 'src/lib/isNilEmpty';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';

export function useRelatedCoursesQuery(courseId?: number) {
  const { key, isAuthenticated } = useCurrentUserKeyEnhancer([QueryKey.RelatedCourses, courseId]);

  return useQuery(
    key,
    () => (courseId ? getRelatedCourses(courseId, isAuthenticated) : undefined),
    {
      enabled: !isNilEmpty(courseId),
    },
  );
}
